import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useT } from "@/app/localization";

const TIMEZONES = [
  { value: "UTC", labelKey: "common.timezone.utc" },
  { value: "America/New_York", labelKey: "common.timezone.america_new_york" },
  { value: "America/Chicago", labelKey: "common.timezone.america_chicago" },
  { value: "America/Denver", labelKey: "common.timezone.america_denver" },
  { value: "America/Phoenix", labelKey: "common.timezone.america_phoenix" },
  { value: "America/Los_Angeles", labelKey: "common.timezone.america_los_angeles" },
  { value: "America/Anchorage", labelKey: "common.timezone.america_anchorage" },
  { value: "Pacific/Honolulu", labelKey: "common.timezone.pacific_honolulu" },
  { value: "Europe/London", labelKey: "common.timezone.europe_london" },
  { value: "Europe/Paris", labelKey: "common.timezone.europe_paris" },
  { value: "Europe/Berlin", labelKey: "common.timezone.europe_berlin" },
  { value: "Europe/Moscow", labelKey: "common.timezone.europe_moscow" },
  { value: "Asia/Dubai", labelKey: "common.timezone.asia_dubai" },
  { value: "Asia/Kolkata", labelKey: "common.timezone.asia_kolkata" },
  { value: "Asia/Shanghai", labelKey: "common.timezone.asia_shanghai" },
  { value: "Asia/Tokyo", labelKey: "common.timezone.asia_tokyo" },
  { value: "Asia/Seoul", labelKey: "common.timezone.asia_seoul" },
  { value: "Australia/Sydney", labelKey: "common.timezone.australia_sydney" },
  { value: "Australia/Melbourne", labelKey: "common.timezone.australia_melbourne" },
  { value: "Pacific/Auckland", labelKey: "common.timezone.pacific_auckland" },
] as const;

interface TimezoneSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export function TimezoneSelect({ value, onChange }: TimezoneSelectProps) {
  const t = useT();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder={t("common.timezone.select_placeholder")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {TIMEZONES.map((tz) => (
            <SelectItem key={tz.value} value={tz.value}>
              {t(tz.labelKey)}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
